import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    var list = request({
        url: 'comMemberRole/selectPageWithRole.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getTreeData = query => {  
    var list = request({
        url: 'haoka/hkChannel/getTreeData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const getCheckData = query => {  
    var list = request({
        url: 'comMemberChannel/checkTreeData.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const saveBind = query => {  
    var list = request({
        url: 'comMemberChannel/saveBind.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

//获取所有成员列表数据
export const changeRole = query => {  
    var list = request({
        url: 'comMemberRole/changeRole.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const channelSelect = query => {   
    var list = request({
        url: 'comMemberChannel/channelSelect.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


export const saveForm = query => {  
    var list = request({
        url: 'comMemberRole/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const handDelete = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'comMemberRole/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comMemberRole/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const updateSave = query => {  
    var list = request({
        url: 'comMemberRole/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handleStatus = query => {  
    var list = request({
        url: 'comMemberRole/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};



export const exchangeMember = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'comMemberRole/exchangeMember.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 




